<div class="why-huiospay">
    <app-new-header></app-new-header>
    <div class="section_one" style="background-image: url('../../../../assets/img/dotted-map.jpg')">
        <div class="overlay">
            <div class="left">
                <h3>We make an impact in ways that improve life far beyond everyone else</h3>
                
            </div>
            <div class="right">
                <img src="../../../../assets/img/whyh-section1.svg" alt="">
            </div>
        </div>
    </div>

    <div class="section_divider">
        <img src="../../../../assets/img/spiralone.png" alt="" class="spiral">
    </div>


    <div class="section_four">
        <div class="top rev">
            <div class="cell">
                <p>WHY HUIOSPAY</p>
                <h3 class="why">Focused and generally business inclusive</h3>
                <div class="subtext">No matter the business type (SMEs, MSEs, Startups, etc) or individual transactions, our financial vision is jealously
                focused and inclusive of all business in both the rural and urban communities, in Nigeria and beyond.</div>
                <div class="items">
            
                    <ul>
                        <li>Accessibility and wide coverage.</li>
                        <li>Reliable security infrastructure.</li>
                        <li>Modern financial technology to help business growth.</li>
                        <li>Fast & easy integrations.</li>
                        <li>Effective customer support & service.</li>
                    </ul>
            
                </div>
            </div>
            <div class="top-image">
                <img src="../../../../assets/img/section4one.jpg" alt="">
            </div>
        </div>
        <div class="top bottom">
            <div class="cell">
                <p>WHY HUIOSPAY</p>
                <h3 class="why">Our solutions are simple, intuitive, modern and interactive.</h3>
                <div class="subtext">Our financial product infrastructure is tailored at providing simple, modern interactive solutions to give our users the
                best possible business experience. We are simply offering impactful solutions with no boundaries, above and beyond.</div>
                
            </div>
            <div class="top-image">
                <img src="../../../../assets/img/womaninoffice.jpg" alt="">
            </div>
        </div>
    </div>

    <div class="section_seven" style="background-image: url('../../../../assets/img/section7.jpg');">
        <div class="join">
            <h3>Join the community of smart business decision makers</h3>
    
            
    
            <button>Open a Merchant Account</button>
        </div>
    </div>

    <app-new-footer></app-new-footer>
</div>